module.exports = __webpack_public_path__ + "static/media/sabrina-2.2345ce7a.wav";